/** Достает поля для обычных и версионных страниц инфралиста */
export const getInfralistDataField = (data, field, versionPage) =>
  versionPage ? data[`${field}_by_version`] : data[field];
